<script>

// Variable global interna para almacenar parametrización del usuario (no se persiste)
const globalParametrizacionUsuario = {
  consultaDocEstadoPedSN: null,
  permiteCreaOCSN: null
}

export default {
  methods: {
    fRespuestaCorrecta(response) {
      return (response.status === 200 && response.data.result !== 'ko' && (response || response.data !== undefined || response.data.dataRes.result !== undefined || response.data.dataRes.result !== null));
    },
    fFormatNumber(value) {
      const spanishFormatter = new Intl.NumberFormat('de-DE')
      return spanishFormatter.format(value)
    },
    fErrorComprobado(error) {
      console.trace('Error')
      console.log(error)
      if (error !== undefined) {
        if (error.data.statusText !== undefined) {
          this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br/>' + error.data.statusText + '  (' + error.data.statusCode + ' ) ')
        }
        if (error.data.exception !== undefined) {
          this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br/>' + error.data.exception)
        }
        if (error.data.errorMsg !== undefined) {
          this.$emit('alert', '<b>' + this.$t('errorDefault') + '</b><br/>' + error.data.errorMsg)
        }
      }
    },
    fRespuestaInterceptado(response) {
      if (response.data.statusCode !== '200' && response.data.errorCode !== undefined && response.data.errorCode !== null) {
        return response.data.errorCode + ' - ' + response.data.errorMsg
      } else {
        return null
      }
    },
    /*
     * Obtiene el valor de un parámetro de la variable global interna
     * Si no está en la variable global, busca en el store y actualiza automáticamente
     */
    getParametrizacionUsuario(parametro) {
      // Si ya está en la variable global y tiene valor, lo retorna
      if (globalParametrizacionUsuario[parametro] !== null && globalParametrizacionUsuario[parametro] !== undefined) {
        return globalParametrizacionUsuario[parametro]
      }
      
      // Si no está en la variable global, busca en el store de autenticación
      if (this.$store && this.$store.getters && this.$store.getters.getAutenticacion) {
        const datosAutenticacion = this.$store.getters.getAutenticacion
        if (datosAutenticacion && datosAutenticacion[parametro] !== null && datosAutenticacion[parametro] !== undefined) {
          // Hace un set individual del parámetro encontrado
          const parametrosUpdate = {}
          parametrosUpdate[parametro] = datosAutenticacion[parametro]
          this.setParametrizacionUsuario(parametrosUpdate)
          return datosAutenticacion[parametro]
        }
      }
      
      return null
    },
    /*
     * Obtiene todo el objeto de parametrización
     */
    getAllParametrizacionUsuario() {
      return globalParametrizacionUsuario
    },
    /*
     * Actualiza la parametrización del usuario
     * @param {Object} parametros - Objeto con los parámetros a actualizar
     * @param {string|null} parametros.consultaDocEstadoPedSN - Valor para consultaDocEstadoPedSN
     * @param {string|null} parametros.permiteCreaOCSN - Valor para permiteCreaOCSN
     */
    setParametrizacionUsuario(parametros) {
      if (parametros && typeof parametros === 'object') {
        // Actualiza cada parámetro que esté definido en el objeto global
        Object.keys(globalParametrizacionUsuario).forEach(key => {
          if (parametros[key] !== undefined) {
            globalParametrizacionUsuario[key] = parametros[key]
          }
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/mixins/globals/mx-global.vue